$(document).ready(function () {
  if (!$('.go-to-element').length) return;

  var footerHeight = $('#footer').outerHeight() || 0;
  var stickyHeight = $('.sticky').outerHeight() || 0;
  var carouselHeight = $('#carousel').outerHeight() || 0;
  var targetScroll = Math.max(carouselHeight - stickyHeight, 0);

  $('.go-to-element').css(
    'min-height',
    $(window).height() - footerHeight - stickyHeight
  );

  $('html, body').stop(true).animate(
    {
      scrollTop: targetScroll
    },
    1000,
    function () {
      $(document).trigger('goToElement:done');
    }
  );
});